import React, { useState, useEffect } from "react";
import { List, Checkbox } from "semantic-ui-react";
import { map, find, reject, orderBy, includes, isEmpty, isNumber } from "lodash";
import PropTypes from "prop-types";
// Redux
import { connect } from "react-redux";
// Styles
import styles from "./styles.module.css";

const MenuSelect = ({ inValue, onValue, disabled = false, menuData }) => {
	const [checkMenus, setCheckMenus] = useState([]);
	const [menus, setMenus] = useState([]);

	useEffect(() => {
		const menuItemArray = map(menuData, (Item) => {
			const subMenuItemArray = map(Item.subMenu, (item) => {
				return { ...item, checked: false, visible: false };
			});
			return {
				...Item,
				subMenu: subMenuItemArray,
				checked: false,
				visible: true,
			};
		});

		const menuItemArrayOrder = orderBy(menuItemArray, ["order"], ["asc"]);
		setMenus(menuItemArrayOrder);
	}, [menuData]);

	useEffect(() => {
		if (!isEmpty(menus)) {
			const checkMenuMap = map(menus, (item) => {
				const subMenuItemArray = map(item.subMenu, (Item) => {
					return {
						...Item,
						checked: includes(inValue, Item.id),
						visible: true,
					};
				});

				return {
					...item,
					subMenu: orderBy(subMenuItemArray, ["order"], ["asc"]),
					checked: includes(inValue, item.id),
					visible: true,
				};
			});

			const checkMenuOrder = orderBy(checkMenuMap, ["order"], ["asc"]);

			setCheckMenus(checkMenuOrder);
		}
	}, [inValue, menus]);

	const sendIdMenu = (array) => {
		let manuIdList = [];

		array.forEach((item) => {
			if (item.checked) {
				manuIdList = [...manuIdList, item.id];
			}

			if (!isEmpty(item.subMenu)) {
				item.subMenu.forEach((Item) => {
					if (Item.checked) {
						manuIdList = [...manuIdList, Item.id];
					}
				});
			}
		});
		onValue(manuIdList);
	};

	const handleCheck = (value) => {
		if (!isNumber(value.parentId)) {
			const checkMenusReject = reject(checkMenus, { id: value.id });
			const checkMenuMap = map(value.subMenu, (item, index) => {
				let firstValueBool = false;
				if (!value.checked) {
					firstValueBool = index === 0;
				} else {
					firstValueBool = false;
				}
				return { ...item, checked: firstValueBool, visible: !value.checked };
			});

			const menuItemArrayOrder = orderBy(
				[...checkMenusReject, { ...value, subMenu: checkMenuMap, checked: !value.checked }],
				["order"],
				["asc"]
			);
			sendIdMenu(menuItemArrayOrder);
			setCheckMenus(menuItemArrayOrder);
		} else if (value.checked) {
			const checkMenusFind = find(checkMenus, { id: value.parentId });
			const checkMenusRejectList = reject(checkMenusFind.subMenu, { id: value.id });

			let bool = true;

			checkMenusRejectList.forEach((item) => {
				if (item.checked) {
					bool = false;
				}
			});

			if (bool) {
				const checkMenusFindVal = find(checkMenus, { id: value.parentId });
				const checkMenusReject = reject(checkMenus, { id: value.parentId });

				const checkMenuMap = map(checkMenusFindVal.subMenu, (item) => {
					return { ...item, checked: false, visible: false };
				});

				const checkMenuMapOrder = orderBy(checkMenuMap, ["order"], ["asc"]);

				const menuItemArrayOrder = orderBy(
					[
						...checkMenusReject,

						{
							...checkMenusFindVal,
							subMenu: checkMenuMapOrder,
							checked: false,
						},
					],
					["order"],
					["asc"]
				);

				setCheckMenus(menuItemArrayOrder);
				sendIdMenu(menuItemArrayOrder);
			} else {
				const checkMenusMinus = find(checkMenus, { id: value.parentId });
				const checkMenusRejectMinus = reject(checkMenus, { id: value.parentId });
				const valueSubMenu = reject(checkMenusMinus.subMenu, {
					id: value.id,
				});
				const checkMenuMapOrder = orderBy([...valueSubMenu, { ...value, checked: false }], ["order"], ["asc"]);
				const menuItemArrayOrder = orderBy(
					[...checkMenusRejectMinus, { ...checkMenusMinus, subMenu: checkMenuMapOrder }],
					["order"],
					["asc"]
				);

				setCheckMenus(menuItemArrayOrder);
				sendIdMenu(menuItemArrayOrder);
			}
		} else {
			const checkMenusFind = find(checkMenus, { id: value.parentId });
			const checkMenusRej = reject(checkMenus, { id: value.parentId });
			const valueSubMenuMinus = reject(checkMenusFind.subMenu, {
				id: value.id,
			});

			const checkMenuMapOrder = orderBy([...valueSubMenuMinus, { ...value, checked: true }], ["order"], ["asc"]);
			const menuItemArrayOrder = orderBy(
				[
					...checkMenusRej,
					{
						...checkMenusFind,
						subMenu: checkMenuMapOrder,
					},
				],
				["order"],
				["asc"]
			);
			setCheckMenus(menuItemArrayOrder);
			sendIdMenu(menuItemArrayOrder);
		}
	};
	const stylesOption = (item) => {
		if (item.visible) {
			if (isNumber(item.parentId)) {
				return styles.contentList;
			}
			return null;
		}
		return styles.contentDNone;
	};
	const RenderMenu = (array) => {
		const menues = map(array, (item, index) => {
			return (
				<List.Item key={index} className={stylesOption(item)}>
					<List.Header>
						<Checkbox
							checked={item.checked}
							onChange={() => {
								handleCheck(item);
							}}
							disabled={disabled}
							className={styles.checkList}
						/>
						<span>{item.name}</span>
					</List.Header>
					{!isEmpty(item.subMenu) && item.checked && <List.List>{RenderMenu(item.subMenu)}</List.List>}
				</List.Item>
			);
		});
		return menues;
	};

	return <List> {RenderMenu(checkMenus)}</List>;
};

MenuSelect.propTypes = {
	onValue: PropTypes.func,
	inValue: PropTypes.array,
	disabled: PropTypes.bool,
	menuData: PropTypes.array,
};

export default connect()(MenuSelect);
